import Button from "../UI/Button";
import styles from "./ErrorBoundaryFallbakc.module.css";

export default function ErrorBoundaryFallback({ error, resetErrorBoundary }) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          Unexpected <br />
          Error
        </div>
        <Button
          onClick={resetErrorBoundary}
          style={{ maxWidth: "min-content", whiteSpace: "nowrap" }}
        >
          Reload Page
        </Button>
      </div>
    </div>
  );
}
